export const WELCOME_STEP_NUMBER = 0;
export const LANGUAGE_STEP_NUMBER = 1;
export const USER_STEP_NUMBER = 2;
export const DATABASE_CONNECTION_STEP_NUMBER = 3;
export const PREFERENCES_STEP_NUMBER = 5;
export const COMPLETED_STEP_NUMBER = 6;

export const STEPS = {
  [WELCOME_STEP_NUMBER]: "welcome",
  [LANGUAGE_STEP_NUMBER]: "language",
  [USER_STEP_NUMBER]: "user_info",
  [DATABASE_CONNECTION_STEP_NUMBER]: "db_connection",
  [PREFERENCES_STEP_NUMBER]: "data_usage",
  [COMPLETED_STEP_NUMBER]: "completed",
};
export const DATABASE_FORM_NAME = "database";
